<script lang="ts">
  import { beforeUpdate, createEventDispatcher, onMount } from 'svelte';
  import { register } from 'swiper/element/bundle';
  import type { SwiperOptions } from 'swiper/types';
  import { isMobileWidth } from '../../../../common/util';
  import ExtraSwiper from '../../../common/components/ExtraSwiper.svelte';
  import PdpBundleTileSlideTemplate from '../../../common/components/PdpBundleTileSlideTemplate.svelte';
  import Text from '../../../common/components/Text.svelte';

  export let data: any;

  var currentProduct = {
    code: data?.code,
    name: data?.name,
    amplienceProductBaseUrl: data?.amplienceProductBaseUrl,
    price: data?.price,
    discountPrice: data?.discountPrice,
    stock: data?.stock,
    brandName: data?.brandName,
    percentageDiscount: data?.percentageDiscount,
    tasheelPriceValuesList: data?.tasheelPriceValuesList,
  };

  const bundleTileSwiperOptions = getSwiperOptions();

  function getSwiperOptions(): SwiperOptions {
    return {
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: true,
    };
  }

  onMount(() => {
    register();
  });

  beforeUpdate(() => {
    try {
      // Early return if data or specialOfferDataList is invalid
      if (!Array.isArray(data?.specialOfferDataList)) {
        throw new Error('specialOfferDataList is not a valid array');
      }

      // Iterate over each special offer in the list
      data.specialOfferDataList.forEach(offer => {
        // Check if specialOfferProducts is an array and exists
        if (Array.isArray(offer?.specialOfferProducts)) {
          // Use a Set for fast lookups of existing product codes
          const existingProductCodes = new Set(offer.specialOfferProducts.map(product => product.code));

          // If currentProduct is not in the set, add it
          if (!existingProductCodes.has(currentProduct.code)) {
            offer.specialOfferProducts.unshift(currentProduct);
          }
        }
      });
    } catch (error) {
      console.error('An error occurred while processing the special offers:', error);
    }
  });

  const dispatcher = createEventDispatcher();

  function onBundleClick(data) {
    dispatcher('bundleClicked', data);
  }
</script>

<div class="promotion-bundle-container">
  <div class="promotion-bundle-container-mobTop" class:hidden={!isMobileWidth()}>
    <section class="promotion-bundle-container-mobTop-first">
      <span class="font-weight-regular font-size-sm"><Text key="extra.specialOfferPsstLable" /></span>
    </section>
    <section class="promotion-bundle-container-mobTop-second">
      <span class="font-weight-bold"><Text key="extra.specialOfferDescLable" /></span>
    </section>
  </div>
  <div class="promotion-bundle-container-title" class:hidden={isMobileWidth()}>
    <Text key="extra.specialOfferDescLable" />
  </div>

  <div class="promotion-bundle-container-inner">
    <ExtraSwiper
      slidesData={data?.specialOfferDataList}
      slideTemplate={PdpBundleTileSlideTemplate}
      swiperOptions={bundleTileSwiperOptions}
      on:click={e => onBundleClick(e.detail)}
    />
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .promotion-bundle-container {
    text-align: center;
    @include desktop-min-width {
      text-align: unset;
    }
    .font-weight-medium {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      @include desktop-min-width {
        font-size: 20px;
        line-height: 22px;
      }
    }

    .font-weight-regular {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: $neutral-dark-02;
    }

    &-title {
      font-size: 36px;
      line-height: 40px;
      font-weight: 700;
      margin-bottom: 50px;
      text-align: left;
    }

    &-mobTop {
      &-first {
        padding: 24px 16px 0;
      }
      &-second {
        padding: 0px 16px 16px;
        font-size: 20px;
        line-height: 22px;
      }
    }

    &-mobBottom {
      margin-top: 16px;
      text-align: center;
      &-first-oriPrice {
        font-size: 11px;
        text-decoration-line: line-through;
        line-height: 12px;
        color: $neutral-dark-03;
      }
      &-second {
        font-size: 10px;
        margin-bottom: 12px;
        .tasheel-price {
          font-size: 10px;
          line-height: 11px;
        }
      }
    }

    .card-container {
      display: flex;
      width: auto;
      max-width: calc(100vw - 32px);
      background: $primary-white;
      border: 1px solid $secondary-gray-02;
      border-radius: 8px;
      flex-direction: column;
      position: relative;
      margin: 0 16px;

      @include desktop-min-width {
        padding: 20px;
        gap: 24px;
        background: $neutral-light-04;
        border-radius: 20px;
        width: max-content;
        margin: 0;
      }

      &-nested-1 {
        position: absolute;
        width: -webkit-fill-available;
        height: 12px;
        left: 12px;
        right: 12px;
        bottom: -12px;
        background: $neutral-light-03;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &-nested-2 {
        position: absolute;
        width: -webkit-fill-available;
        height: 12px;
        left: 24px;
        right: 24px;
        bottom: -24px;
        background: $neutral-light-04;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &-pdpButton {
        padding: 0 16px 20px;
      }

      &-text {
        padding: 16px 0 16px 16px;
        text-align: left;
        .card-subeading {
          margin-top: 2px;
        }
        @include desktop-min-width {
          padding: 0px;
          display: grid;
          white-space: nowrap;
        }
      }

      &-inn {
        display: flex;
        padding: 0 16px;
        overflow: scroll;
        justify-content: center;
        gap: 8px;
        @include desktop-min-width {
          padding: 0px;
        }

        .mobile-card-view {
          width: 98px;
          padding: 6px;
        }

        &-tag {
          text-align: left;
          height: 20px;
          margin: 8px 0 0 8px;
          position: absolute;
        }

        &-imgContaniner {
          width: 86px;
          height: 76px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        &-desc {
          margin: 4px 0 2px;
          font-size: 9px;
          line-height: 10px;
          width: 86px;
          height: 30px;
          max-width: 87px;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $neutral-dark-03;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          line-clamp: 3;

          &-brandName::after {
            content: ' \2022 ';
          }
        }

        &-price {
          font-size: 12px;
          line-height: 14px;
          text-align: center;
        }
      }
    }
  }

  .hidden {
    display: none;
  }

  .card-container-inn {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  :global {
    .promotion-bundle-container-inner {
      .swiper-slide {
        width: auto;
      }
      .extra-swiper-container .swiper-button-next {
        transform: none !important;
      }
      .extra-swiper-container .swiper-button-prev {
        transform: none !important;
      }
    }
    @include responsive {
      .promotion-bundle-container .promotion-bundle-container-inner {
        swiper-container::part(button-prev),
        swiper-container::part(button-next) {
          height: 34px;
          width: 34px;
        }
      }
    }
  }
</style>
